import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GraphStateService } from "../core-module/services/state/graph-state.service";
import { renderOtpDeratingGraph } from "../shared-module/graph-utils/otp-derating-graph";

@Component({
  standalone: false,
  selector: "app-otp-ftp-graph",
  templateUrl: "./otp-ftp-graph.component.html",
  styleUrls: ["./otp-ftp-graph.component.scss"],
})
export class OtpFtpGraphComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  // Kept as explicit public state for template/tests and API compatibility.
  readonly inputXRange: [number, number] = [0, 15];
  readonly inputYRange: [number, number] = [0, 100];

  // Default dim level used before a schema-driven payload arrives.
  private static readonly DEFAULT_MIN_DIM_LEVEL = 10;

  data: any[] = [
    { x: 15, y: 100 },
    { x: 9.693, y: 100 },
    { x: 8.48,  y: OtpFtpGraphComponent.DEFAULT_MIN_DIM_LEVEL },
    { x: 0,     y: OtpFtpGraphComponent.DEFAULT_MIN_DIM_LEVEL },
  ];

  constructor(private graphState: GraphStateService) {}

  ngOnInit() {
    this.buildGraph();

    this.graphState.getOtpFtpGraphData
      .pipe(takeUntil(this.destroy$))
      .subscribe((payload) => {
        if (payload) {
          this.data = this.buildDataPoints(payload.dimStart, payload.dimStop, payload.minDimLevel);
        }
        this.buildGraph();
      });
  }

  private buildDataPoints(dimStartOhm: number, dimStopOhm: number, minDimLevel?: number): any[] {
    const startKOhm = Math.min(15, Math.max(0, dimStartOhm / 1000));
    const stopKOhm  = Math.min(15, Math.max(0, dimStopOhm  / 1000));
    // Dim level for the low-temperature plateau comes from the DimStop schema
    // (`minDimLevel`). Fall back to the historical 10% when not provided.
    const dimLevel = (typeof minDimLevel === 'number' && !isNaN(minDimLevel))
      ? minDimLevel
      : OtpFtpGraphComponent.DEFAULT_MIN_DIM_LEVEL;

    return [
      { x: 15,         y: 100 },
      { x: startKOhm,  y: 100 },
      { x: stopKOhm,   y: dimLevel },
      { x: 0,          y: dimLevel },
    ];
  }

  private buildGraph() {
    renderOtpDeratingGraph(this.data, {
      svgId: "otpFtpGraphSvg",
      gradientId: "otpFtpGradient",
      xAxisLabel: "Resistance (kΩ)",
      chartHeight: 360,
      xDomain: [this.inputXRange[1], this.inputXRange[0]], // right-to-left resistance axis
      yDomain: this.inputYRange,
      xTicks: 16,
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
